export const isImage = type => {
  return type.indexOf('image/') >= 0 || type.indexOf('img/') >= 0
}
